import React from "react"

import TableComponent from "./grant-table-component"

import Header from './header-container'

class GrantTableContainer extends React.Component {

	render() {
		const tableDefinition = {
			rows: this.props.row.project.grants.filter(g => (this.props.row.type == "awarded" ? g.awarded : !g.awarded)).map((grant, index) => ({
				title: grant.grant.name,
				grant: grant,
				project: this.props.row.project,
				theme: this.props.row.theme,
				subtheme: this.props.row.subtheme,
				cellComponents: [{
					index: 0,
					component: Header
				}],
				disabledCells: [2],
				index: index,
				className: "grant-amount",
				cellProps: {
					format  : "0,0",
					language: "fr-FR",
					type    : "numeric",
					mantissa: 0
				},
				//readOnly: this.props.row.type == "awarded"
			}))
		}

		if (tableDefinition.rows.length) {
			return (
				<TableComponent 
					tableDefinition={tableDefinition}
					data={this._getData(tableDefinition)} 
					current_year={this.props.current_year}
					awarded={this.props.row.type == "awarded"}
					ppi={this.props.ppi}
					onChange={this.props.onChange}
					onCustomAction={this._handleCustomAction.bind(this)}
				/>
			)
		} else {
			return <div className="no-grant-label">Aucune subvention</div>
		}
	}

	_getData(tableDefinition) {
		const ppi = this.props.ppi
		var data = new Array(tableDefinition.rows.length)
		var value, rest
		const project = this.props.row.project
		var yindex
		project.grants.filter(g => (this.props.row.type == "awarded" ? g.awarded : !g.awarded)).map((grant, index) => {
			data[index] = new Array(grant.years.filter(y => (y.year >= this.props.current_year)).length)
			rest = 0
			yindex = 0
			grant.years.map(year => {
				if (year.year >= this.props.current_year) {
					data[index][yindex] = Math.round(year.amount)
					yindex++
				}
				rest += year.amount ? year.amount : 0
			})

			rest = grant.budget - rest
			data[index].unshift(rest == 0 ? "" : rest)
			data[index].unshift(grant.budget)
			data[index].unshift(grant.grant.name)
		})
		return data
	}

	_handleCustomAction = (type, data) => {
		if (type == "new_grant") {
			this.props.onCustomAction("new_grant", {project: this.props.row.project, awarded: this.props.row.type == "awarded"})
		} else {
			this.props.onCustomAction(type, data)
		}
	}

}

export default GrantTableContainer



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/grants/grant-table-container.js